import { useRef, useState, useEffect } from "react";
import { faCheck, faTimes, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import useAxiosPrivate from '../hooks/useAxiosPrivate';

const EMAIL_REGEX = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;

export default function UserEdit(props) {

  const { user, setUsers } = props;

  const axiosPrivate = useAxiosPrivate()



  //URLS

  const EDIT_URL = `/users/edit`;
  const USERS_URL = `/users`;


  //States


  const id = user._id



  // console.log(roles)

  const emailRef = useRef();
  const errRef = useRef();

  const [email, setEmail] = useState(user.email);
  const [validEmail, setValidEmail] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);

  const [errMsg, setErrMsg] = useState('');


  useEffect(() => {
    emailRef.current.focus();
  }, [])

  useEffect(() => {
    setValidEmail(EMAIL_REGEX.test(email));
  }, [email])

  useEffect(() => {
    setErrMsg('');
  }, [user])

  //console.log(roles)

  //Edit function

  const editUser = async (e) => {
    e.preventDefault()

    try {
      const body = {
        id, email
      };
      // console.log("body front", body)

      await axiosPrivate.put(
        EDIT_URL, body
      )
      axiosPrivate.get(USERS_URL).then(function (res) {
        setUsers([...res.data]);


      });
    } catch (err) {
      if (!err?.response) {
        setErrMsg('No Server Response');
      } else if (err.response?.status === 400) {
        setErrMsg('Missing information');
      } else if (err.response?.status === 401) {
        setErrMsg('Unauthorized');
      } else if (err.response?.status === 403) {
        setErrMsg('Changes restricted for this user by the developer');
      } else if (err.response?.status === 409) {
        setErrMsg('Email already exists');
      } else {
        setErrMsg('Operation Failed');
      }
      errRef.current.focus();
    }
  }




  return (
    <div>
      <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
      {/* <!-- Button to Open the Modal --> */}
      <button
      title="Click to edit"
        type="button"
        className="btn-no-btn "
        data-toggle="modal"
        data-target={`#editusermodal${user._id}`}
      // data-backdrop="static"
      >
        {/* {user.email} */}
        <i className="fa-solid fa-at
min-padding-side"></i>
      </button>

      {/* <!-- The Modal --> */}
      <div className="modal" id={`editusermodal${user._id}`}>
        <div className="modal-dialog">
          <div className="modal-content">

            {/* <!-- Modal Header --> */}
            <div className="modal-header">
              <h4 className="modal-title">Edit Email</h4>
              <button type="button" className="close" data-dismiss="modal">&times;</button>
            </div>

            {/* <!-- Modal body --> */}
            <div className="modal-body">

              <label htmlFor="email"
              className="edit-item ">
                {/* Email: */}
                <FontAwesomeIcon icon={faCheck} className={validEmail ? "valid" : "hide"} />
                <FontAwesomeIcon icon={faTimes} className={validEmail || !email ? "hide" : "invalid"} />
              </label>
              <input
              className="--wider"
                type="text"
                id={email}
                autoComplete="off"
                ref={emailRef}
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                required
                aria-invalid={validEmail ? "false" : "true"}
                aria-describedby="emailnote"
                onFocus={() => setEmailFocus(true)}
                onBlur={() => setEmailFocus(false)}
              />
              <p id="emailnote" className={emailFocus && email && !validEmail ? "instructions" : "offscreen"}>
                <FontAwesomeIcon icon={faInfoCircle} />
                Must be a valid email address. Special characters allowed . - _
              </p>






            </div>

            {/* <!-- Modal footer --> */}
            <div className="modal-footer">
              <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
              <button
                disabled={!validEmail ? true : false}
                type="button"
                className="btn button-black"
                data-dismiss="modal"
                onClick={e => editUser(e)}
              >Edit</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}
